import * as THREE from 'three'

/** PlayCanvas gsplat 每个 draw instance 承载的 splat 数量。 */
export const GSPLAT_INSTANCE_SIZE = 128

/** 每个 batched instance 的 quad 数量对应的 index count。 */
export const GSPLAT_BATCH_INDEX_COUNT = GSPLAT_INSTANCE_SIZE * 6

/** 每个 batched instance 的顶点数量。 */
export const GSPLAT_BATCH_VERTEX_COUNT = GSPLAT_INSTANCE_SIZE * 4

/**
 * 根据可见 splat 数量计算前向 splat geometry 的 draw instance 数量。
 *
 * @param visibleSplatCount - 当前真正可见的 splat 数量
 * @returns batched draw instance 数量
 */
export function getGSplatBatchInstanceCount(visibleSplatCount: number): number {
  const count = Math.max(0, Math.floor(visibleSplatCount))
  return count === 0 ? 0 : Math.ceil(count / GSPLAT_INSTANCE_SIZE)
}

/**
 * 构建 PlayCanvas 风格的 128-splat batched quad geometry。
 *
 * position.z 存储 batch 内 splat 偏移，四个顶点共享同一偏移。
 *
 * @param geometry - 目标 geometry
 */
export function setBatchedSplatQuadGeometry(
  geometry: THREE.BufferGeometry | THREE.InstancedBufferGeometry
): void {
  const positions = new Float32Array(GSPLAT_BATCH_VERTEX_COUNT * 3)
  const uvs = new Float32Array(GSPLAT_BATCH_VERTEX_COUNT * 2)
  const indices = new Uint16Array(GSPLAT_BATCH_INDEX_COUNT)

  for (let i = 0; i < GSPLAT_INSTANCE_SIZE; i++) {
    const vertexBase = i * 4
    const positionBase = vertexBase * 3
    const uvBase = vertexBase * 2
    const indexBase = i * 6

    positions.set([-1, -1, i, 1, -1, i, 1, 1, i, -1, 1, i], positionBase)

    uvs.set([-1, -1, 1, -1, 1, 1, -1, 1], uvBase)

    indices.set(
      [vertexBase, vertexBase + 1, vertexBase + 2, vertexBase, vertexBase + 2, vertexBase + 3],
      indexBase
    )
  }

  geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
  geometry.setAttribute('uv', new THREE.BufferAttribute(uvs, 2))
  geometry.setIndex(new THREE.BufferAttribute(indices, 1))
}
